var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExclamationTriangle = function SvgExclamationTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 16"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#040404",
    fillRule: "evenodd",
    d: "M17.233 14.325 9.708.911a.817.817 0 0 0-1.417 0L.768 14.325a.8.8 0 0 0-.1.382.8.8 0 0 0 .808.793h15.05a.8.8 0 0 0 .39-.098.785.785 0 0 0 .318-1.077m-14.39-.41L9 2.937l6.158 10.978zm5.349-2.378c0-.438.355-.793.792-.793h.032a.793.793 0 1 1 0 1.586h-.032a.793.793 0 0 1-.792-.793M9 6.781a.81.81 0 0 0-.808.809v1.554a.808.808 0 0 0 1.617 0V7.59A.81.81 0 0 0 9 6.782",
    clipRule: "evenodd"
  })));
};
export default SvgExclamationTriangle;